import { Store } from 'redux'
import * as routes from "./../constans/routes.constants";
import { push } from 'react-router-redux';

export function AppInit(store: Store<any>) {
    if (document.URL.indexOf(routes.APP_URI) === -1) {
        store.dispatch(push(routes.APP_URI));
    }
}